import { useState } from "react";
import { useTheme } from "styled-components";
import {
  EIGHT_SYMBOLS_REGEX,
  LOWER_CASE_REGEX,
  NUMBER_REGEX,
  PASSWORD_REGEX,
  SPECIAL_SYMBOL_REGEX,
  UPPER_CASE_REGEX,
} from "@shared/common/constants";

const usePasswordSection = () => {
  const appTheme = useTheme();
  const [password, setPassword] = useState<string>();
  const [showPasswordValidation, setShowPasswordValidation] = useState(false);

  const isPasswordValid = (password?: string) =>
    password && checkPassword(password);
  const validatePassword = (argsPassword?: string) => {
    const isValid = isPasswordValid(argsPassword || password);
    if (isValid) {
      setShowPasswordValidation(false);
    } else {
      setShowPasswordValidation(true);
    }
    return isValid;
  };

  const onPasswordChange = (password?: string) => {
    setPassword(password);
    return validatePassword(password);
  };

  const checkPassword = (password: string) => {
    return PASSWORD_REGEX.test(password);
  };

  const getValidationItem = (text: string, isValid: boolean) => ({
    style: { marginBottom: 8 },
    isValid,
    color: isValid ? appTheme.colors.green : appTheme.colors.red,
    text: text,
  });

  const validationData = Object.values(PasswordCondition).map((condition) => {
    const isValid =
      !!password && PasswordConditionToRegex[condition].test(password);
    return getValidationItem(condition, isValid);
  });
  if (password && password.length >= 100) {
    validationData.push(getValidationItem("Less than 100 characters", false));
  }

  return {
    password,
    validationTitle: "Password has to contain at least:",
    validationData,
    onBlur: () => setShowPasswordValidation(false),
    onFocus: () => validatePassword(),
    validatePassword,
    onPasswordChange,
    showPasswordValidation,
    isPasswordValid: isPasswordValid(password),
  };
};

export default usePasswordSection;

export interface ValidationItemData {
  style: any;
  isValid: boolean;
  color: string;
  text: string;
}

enum PasswordCondition {
  NUM_OF_SYMBOLS = "8 Characters",
  SPECIAL_SYMBOL = "1 Special Character",
  UPPER_CASE = "1 Uppercase Character",
  LOWER_CASE = "1 Lowercase Character",
  NUMBER = "1 Number",
}

const PasswordConditionToRegex = {
  [PasswordCondition.NUM_OF_SYMBOLS]: EIGHT_SYMBOLS_REGEX,
  [PasswordCondition.SPECIAL_SYMBOL]: SPECIAL_SYMBOL_REGEX,
  [PasswordCondition.UPPER_CASE]: UPPER_CASE_REGEX,
  [PasswordCondition.LOWER_CASE]: LOWER_CASE_REGEX,
  [PasswordCondition.NUMBER]: NUMBER_REGEX,
};
